module.exports = __webpack_public_path__ + "img/gold.8846e5d8.svg";